module.exports = __webpack_public_path__ + "img/2.5b5ade1d.png";